import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { colors, heading5, spacing } from 'ui/theme';
import styled from 'styled-components';
import { Link } from 'ui/links';
import { Body2LightNoMargin } from 'modules/frequencyManagement/components/Content.styles';
import { FiltersAndSearch } from 'modules/frequencyManagement/components/messageType/FiltersAndSearch';
import {
  MessageTypeHeaderText,
  createMessageTypeSecondaryText,
} from 'modules/frequencyManagement/components/messageType/MessageTypesCard.constants';

const Wrapper = styled.div`
  align-items: center;
  border-bottom: solid 1px ${colors.borderPrimarySubtle};
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: ${spacing.half};
  row-gap: ${spacing.half};
  padding: ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.plusHalf};
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    row-gap: ${spacing.base};
  }
`;

const H5 = styled.h5`
  ${heading5};
  margin-bottom: ${spacing.half};
`;

const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const LinkWithFlex = styled(Link)`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.quarter};
  margin-left: ${spacing.quarter};
  svg {
    flex-shrink: 0;
  }
`;

export const CardHeader = ({ messageMedium }: { messageMedium: SupportedMediums }) => {
  return (
    <Wrapper>
      <div>
        <H5>{MessageTypeHeaderText}</H5>
        <Flex>
          <Body2LightNoMargin>
            {createMessageTypeSecondaryText(messageMedium)}
            <LinkWithFlex
              href="https://support.iterable.com/hc/en-us/articles/15342990564372-Frequency-Management"
              target="_blank"
              hasOpenNewTabIcon
            >
              Learn more
            </LinkWithFlex>
          </Body2LightNoMargin>
        </Flex>
      </div>
      <FiltersAndSearch messageMedium={messageMedium} />
    </Wrapper>
  );
};
